import { useTranslation } from 'react-i18next';
import React from 'react';
void React;
import publicHomepageContent from '../../content/publicHomepageContent';
import IconMonitor from '../../assets/assets/System/Monitor.svg';
import KrinkelsKOutline from './KrinkelsKOutline';
// ensure imported component is recognized by linters in all configs
void KrinkelsKOutline;

export default function RobotInfoSection() {
  const { t } = useTranslation();
  const { headline, intro, infoPoints } = t('homepageContent', { returnObjects: true, defaultValue: publicHomepageContent });
  return (
    <section className="kr-section kr-info-section" aria-labelledby="info-heading">
      <div className="kr-shell info-shell">
        <div className="kr-info-inner">
          <KrinkelsKOutline className="" />
          <div className="kr-info-copy">
            <h2 id="info-heading" className="k-h2">{headline}</h2>
            <p className="k-body kr-intro">{intro}</p>
            <div className="kr-info-points editorial-list">
              {infoPoints.map((p) => (
                <div key={p.key} className="kr-info-point">
                  <div className="kr-info-icon" aria-hidden><img src={IconMonitor} alt="" width="28" height="28" /></div>
                  <div>
                    <div className="kr-info-title">{p.title}</div>
                    <div className="kr-info-text">{p.text}</div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
